export default __webpack_public_path__ + "static/blue-bg-9e4b248b9eb46a4632503ecb552ac9b6.png";